export enum FundFrequency {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Annually = 'annually',
  Varies = 'varies',
  OneTime = 'one_time'
}
